var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTeaAttrsContext } from '../../context/TeaAttrsContext';
import { EditorComponentContainer } from './style';
/**
 * Generate Editor Field Component with function
 * @param name Component Name
 * @param fn Component Builder Fn
 * @returns A Saucer Editor Field
 */
export function buildEditorFields(name, fn) {
    var SaucerEditorField = React.memo(function (props) {
        var field = props.field, _a = props.label, label = _a === void 0 ? '' : _a, children = props.children, custom = __rest(props, ["field", "label", "children"]);
        var _b = useTeaAttrsContext(), currentTeaAttrs = _b.currentTeaAttrs, setCurrentTeaAttrs = _b.setCurrentTeaAttrs;
        return (React.createElement(EditorComponentContainer, { label: label }, fn(__assign(__assign({}, custom), { // TODO: I have not a good idea to create this type
            field: field,
            label: label,
            currentTeaAttrs: currentTeaAttrs,
            setCurrentTeaAttrs: setCurrentTeaAttrs }))));
    });
    SaucerEditorField.displayName = "SaucerEditorField(" + name + ")";
    return SaucerEditorField;
}
